var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Axios from 'axios';
import * as actions from './api-creators';
import { toast } from 'react-toastify';
import { logout } from '../../utils/auth';
var baseURL = process.env.REACT_APP_BACKEND_URL;
var api = function (_a) {
    var dispatch = _a.dispatch;
    return function (next) {
        /* eslint-disable consistent-return */
        return function (action) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, url, method, data, onStart, onSuccess, onError, userToken, headers, response, error_1, status;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (action.type !== actions.apiCallBegan.type)
                            return [2 /*return*/, next(action)];
                        _a = action.payload, url = _a.url, method = _a.method, data = _a.data, onStart = _a.onStart, onSuccess = _a.onSuccess, onError = _a.onError;
                        if (onStart)
                            dispatch({ type: onStart, payload: {} });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        userToken = localStorage.getItem('user-token') || '';
                        console.log(userToken, 'userToken', url);
                        if (data && data.access_token) {
                            userToken = data.access_token;
                        }
                        headers = { Authorization: "Bearer ".concat(userToken) };
                        return [4 /*yield*/, Axios.request({
                                baseURL: baseURL,
                                url: url,
                                method: method,
                                data: data,
                                headers: headers,
                            })];
                    case 2:
                        response = _b.sent();
                        /* eslint-disable consistent-return */
                        if (response.headers.Authorization) {
                            response.data.data.token = response.headers.Authorization || '';
                        }
                        if (onSuccess) {
                            dispatch({ type: onSuccess, payload: response.data });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        status = error_1.response.status;
                        if (status === 401) {
                            toast.dismiss(); // i need to hide all toast notification
                            toast.error('Session Expired', {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                            logout();
                            window.location.href = '';
                        }
                        if (onError) {
                            console.log(error_1);
                            dispatch({
                                type: onError,
                                payload: error_1.response.data.errors || {},
                            });
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        next(action);
                        return [2 /*return*/];
                }
            });
        }); };
    };
};
export default api;
